import { render, staticRenderFns } from "./ImagePreviewDialog.vue?vue&type=template&id=508d061a&scoped=true"
import script from "./ImagePreviewDialog.vue?vue&type=script&lang=js"
export * from "./ImagePreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./ImagePreviewDialog.vue?vue&type=style&index=0&id=508d061a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508d061a",
  null
  
)

export default component.exports